/**
 * Alle Inhalte der Seite an einem Ort.
 * PLATZHALTER sind markiert: Kontaktdaten, Firmierung, Kostenverteilung,
 * Referenzen, Kundenstimmen, Rechtsseiten.
 */

export const site = {
  brand: "Flottmacher",
  domain: "flottmacher.com",
  claim: "3 Tage bis zum Entwurf. 0 € bis zu deinem Ja.",
  // Betreiberin laut Impressum, Angaben wie auf repufox.com/impressum
  legalName: "RepuFox LLC",
  legalAddress: ["8206 Louisiana Blvd NE, Suite A", "Albuquerque, NM 87113", "USA"],
  legalRep: "Teia O. Nika",
  // Der Ablauf in Zahlen
  callMinutes: 60,
  devHours: 5,
  draftDays: 3,
  feedbackRounds: 2,
  // PLATZHALTER: echte Nummer und Adresse eintragen
  phoneDisplay: "+49 40 000 000 00",
  phoneLink: "tel:+494000000000",
  whatsapp:
    "https://wa.me/491700000000?text=Hallo%20Flottmacher%2C%20ich%20interessiere%20mich%20f%C3%BCr%20eine%20neue%20Website.",
  email: "hallo@flottmacher.com",
  nav: [
    { label: "Ablauf", href: "#ablauf" },
    { label: "Beispiel", href: "#entwurf" },
    { label: "Preise", href: "#leistungen" },
    { label: "Team", href: "#team" },
    { label: "Referenzen", href: "#referenzen" },
    { label: "FAQ", href: "#faq" },
  ],
};

/** Die drei Schritte im Hero (Kurzfassung des Ablaufs). */
export const heroSteps = [
  { title: "60 Minuten Beratung.", text: "Wir hören genau zu, was dein Betrieb braucht." },
  {
    title: "Nach 3 Tagen: Entwurf und Festpreis.",
    text: "Gefällt er dir nicht, zahlst du nichts.",
  },
  {
    title: "Umsetzung und Livegang.",
    text: "Zwei Feedbackrunden, gehostet auf deinen Namen.",
  },
];

// Auf der Seite nur mit Vornamen.
export const people = {
  pms: [
    {
      id: "patrick",
      name: "Patrick",
      role: "Deutsche Projektleitung",
      text: "Dein erster Anruf landet bei ihm. Er führt das Beratungsgespräch, schreibt die Texte, zeigt dir den Entwurf und bleibt bis zum Livegang dein Kontakt. Kommt aus Film, Fotografie und Markenmarketing und weiß, wie sich ein Betrieb zeigen will.",
    },
  ],
};

/** Was du von deinem Ansprechpartner bekommst. */
export const contactPoints = [
  "Muttersprachler, keine Übersetzungsschleife",
  "Erreichbar zu deutschen Bürozeiten",
  "Ein fester Ansprechpartner pro Projekt",
  "Antwort meist am selben Werktag",
];

export const stats = [
  { value: "3 Tage", label: "bis zum ersten Entwurf", sub: "nach dem Beratungsgespräch, kostenlos" },
  { value: "0 €", label: "Anzahlung", sub: "Rechnung erst nach Auslieferung" },
  { value: "100 %", label: "deutsche Projektleitung", sub: "Muttersprachler, deutsche Bürozeiten" },
  { value: "bis 50 %", label: "unter deutschen Agenturpreisen", sub: "bei gleicher Qualität" },
];

/** Wie der Preis zustande kommt. Die internationale Entwicklung ist ein Grund unter mehreren, nicht das Verkaufsargument. */
export const pricePoints = [
  {
    title: "Kein teures Büro, kein Vertrieb.",
    text: "Bei einer klassischen Agentur geht rund die Hälfte des Preises in Miete, Verwaltung, Vertrieb und Marge. Bei uns ist es ein Bruchteil davon.",
  },
  {
    title: "Entwickelt mit internationalen Teams.",
    text: "Wir arbeiten mit erfahrenen Teams und Freelancern weltweit, wie es große Firmen seit Jahren tun. Gleiche Werkzeuge, gleiche Standards, faire Stundensätze.",
  },
  {
    title: "Gesteuert von deinem deutschen Projektleiter.",
    text: "Du sprichst nur mit Patrick. Er übersetzt deine Wünsche in klare Aufgaben und prüft jedes Ergebnis, bevor du es siehst.",
  },
];

export type Segment = { key: string; label: string; agency: number; us: number };

// Beispielhafte Verteilung, gerundet. PLATZHALTER: mit echten Zahlen abgleichen.
export const costSegments: Segment[] = [
  { key: "dev", label: "Entwicklung und Design", agency: 35, us: 60 },
  { key: "pm", label: "Projektleitung", agency: 15, us: 25 },
  { key: "office", label: "Büro und Verwaltung", agency: 30, us: 10 },
  { key: "sales", label: "Vertrieb und Marge", agency: 20, us: 5 },
];

export type RiskIcon = "key" | "server" | "eye" | "receipt";

/** Banner „Klingt zu günstig?“ */
export const riskPoints: { icon: RiskIcon; title: string; text: string }[] = [
  {
    icon: "key",
    title: "Code und Rechte gehören dir.",
    text: "Du bekommst den kompletten Quellcode und alle Nutzungsrechte. Du bist nie von uns abhängig.",
  },
  {
    icon: "server",
    title: "Gehostet in Deutschland.",
    text: "Auf deinem eigenen Server bei IONOS, Strato oder wo du willst. Alles läuft auf deinen Namen.",
  },
  {
    icon: "eye",
    title: "Erst der Entwurf.",
    text: "Du siehst deine neue Website, bevor du irgendetwas zusagst. Gefällt sie nicht, war es das.",
  },
  {
    icon: "receipt",
    title: "Rechnung nach Auslieferung.",
    text: "Keine Anzahlung. Die Rechnung kommt erst, wenn deine fertige Seite bei dir ist.",
  },
];

export type PackageTone = "light" | "brand" | "dark";

/** Drei Pakete. Festpreise zzgl. USt. */
export const services: {
  title: string;
  price: string;
  priceNote?: string;
  text: string;
  cta: string;
  tone: PackageTone;
  badge?: string;
}[] = [
  {
    title: "Onepager",
    price: "1.499 €",
    priceNote: "Festpreis",
    text: "Eine Seite, auf der alles steht. Ideal für kleine Betriebe, Kampagnen oder Stellenanzeigen.",
    cta: "Entwurf anfragen",
    tone: "light",
  },
  {
    title: "Website",
    price: "1.999 €",
    priceNote: "Festpreis",
    text: "Mehrere Unterseiten für Leistungen, Über uns, Referenzen und Kontakt. Der Standard für die meisten Betriebe.",
    cta: "Entwurf anfragen",
    tone: "brand",
    badge: "Meistgebucht",
  },
  {
    title: "Individuell",
    price: "Nach Absprache",
    text: "Relaunch, mehrere Sprachen oder API-Anbindungen an CRM, Buchungs- und Warenwirtschaftssysteme. Der Festpreis kommt mit dem Entwurf.",
    cta: "Projekt besprechen",
    tone: "dark",
  },
];

/** Was in jedem Paket drin ist. */
export const included = [
  "Texte und Bilder",
  "Entwurf vorab kostenlos",
  "2 Feedbackrunden",
  "Optimiert fürs Handy",
  "DSGVO-konform",
  "Hosting und Code auf deinen Namen",
  "Technische SEO-Grundlagen",
  "Ein fester Ansprechpartner",
];

/** Sektion „So sieht ein Entwurf aus“: Demo-Entwurf in public/demo/zimmerei, Screenshots per node mockup/render.cjs. */
export const draftDemo = {
  url: "/demo/zimmerei/index.html",
  address: "vorschau.flottmacher.com/zimmerei-thalmann",
  points: [
    "Deine Startseite als echte Website, nicht als Bild",
    "Für Rechner und Handy, unter einer Vorschau-Adresse zum Durchklicken",
    "Mit Texten für deinen Betrieb, deinem Logo und deinen Farben",
    "Dazu das Angebot mit Festpreis für die komplette Seite",
  ],
};

/** Sektion „Bei Google gefunden werden“: was in jedem Paket steckt. */
export const seoBasics = [
  {
    title: "Schnell und sauber gebaut.",
    text: "Kurze Ladezeiten und saubere Technik, die auf dem Handy genauso gut funktioniert. Darauf schaut Google zuerst.",
  },
  {
    title: "Titel und Beschreibung für jede Seite.",
    text: "So, wie sie in den Suchergebnissen stehen sollen, mit den Begriffen, nach denen deine Kunden suchen.",
  },
  {
    title: "Strukturierte Daten für deinen Betrieb.",
    text: "Adresse, Öffnungszeiten und Leistungen in einer Form, die Google direkt versteht.",
  },
  {
    title: "Bei Google angemeldet.",
    text: "Sitemap und Google Search Console richten wir ein, damit deine Seite schnell im Index landet.",
  },
];

/** Lokale Sichtbarkeit als Zusatz, Preis nach Absprache. */
export const localVisibility = [
  {
    title: "Google-Unternehmensprofil",
    text: "Einrichten oder übernehmen, vollständig ausfüllen und mit deiner Website verbinden. Das ist der Eintrag mit Karte, Öffnungszeiten und Sternen.",
  },
  {
    title: "Bewertungen",
    text: "Mehr echte Bewertungen von zufriedenen Kunden, professionelle Antworten und unfaire Bewertungen prüfen lassen.",
  },
  {
    title: "Ranking-Messung",
    text: "Wir messen, auf welchem Platz du bei Google Maps stehst. Nicht nur an deiner Adresse, sondern im ganzen Einzugsgebiet.",
  },
];

export const steps = [
  {
    nr: "1",
    title: "60 Minuten Beratungsgespräch.",
    text: "Wir hören genau zu: was deine Firma macht, wen die Seite erreichen soll, was heute fehlt und was sie können muss. Per Telefon oder Video, mit deinem Projektleiter.",
    tag: "Kostenlos · 60 Minuten",
    highlight: false,
  },
  {
    nr: "2",
    title: "Fünf Entwicklerstunden, dann der Entwurf.",
    text: "Ein Entwickler nimmt sich fünf Stunden. Was dabei entsteht, zeigen wir dir drei Tage nach dem Gespräch, zusammen mit einem konkreten Angebot für das fertige Projekt. Gefällt dir das nicht, war es das. Kostenlos.",
    tag: "Kostenlos · nach 3 Tagen",
    highlight: true,
  },
  {
    nr: "3",
    title: "Umsetzung mit bis zu zwei Feedbackrunden.",
    text: "Wir bauen die komplette Seite. Du bekommst einen Vorschau-Link, gibst Feedback, wir passen an. Bis zu zwei Runden sind im Festpreis drin.",
    tag: "Festpreis · 2 Feedbackrunden",
    highlight: false,
  },
  {
    nr: "4",
    title: "Auslieferung, dann Rechnung.",
    text: "Domain und Hosting registrieren wir gemeinsam mit dir bei IONOS, Strato oder wo du willst, auf deinen Namen. Du bekommst Code und alle Rechte. Erst danach kommt die Rechnung.",
    tag: "Keine Anzahlung",
    highlight: false,
  },
];

/** Erklärvideo unter dem Ablauf (Quelle: explainer-video, Version 3, als Web-Fassung in public/video). */
export const explainerVideo = {
  src: "/video/flottmacher-erklaervideo.mp4",
  poster: "/video/flottmacher-erklaervideo.jpg",
  duration: "1:29",
  label: "Erklärvideo: So läuft dein Projekt bei Flottmacher",
  title: "Der ganze Ablauf in 89 Sekunden.",
};

// PLATZHALTER: Referenzen folgen
export type Tone = "navy" | "brand" | "slate";
export const caseStudies: { id: string; trade: string; place: string; tone: Tone }[] = [
  { id: "01", trade: "Maschinenbau", place: "Bielefeld", tone: "navy" },
  { id: "02", trade: "Steuerberatung", place: "Hamburg", tone: "brand" },
  { id: "03", trade: "Logistik", place: "Bremen", tone: "slate" },
  { id: "04", trade: "Medizintechnik", place: "Lübeck", tone: "brand" },
  { id: "05", trade: "Ingenieurbüro", place: "Hannover", tone: "slate" },
  { id: "06", trade: "Großhandel", place: "Kiel", tone: "navy" },
];

// PLATZHALTER: Kundenstimmen folgen
export const testimonials = [
  { id: "01", trade: "Geschäftsführer, Maschinenbau", place: "Ostwestfalen" },
  { id: "02", trade: "Marketingleitung, Logistik", place: "Norddeutschland" },
];

export const faq = [
  {
    q: "Mit wem spreche ich im Projekt?",
    a: "Nur mit deinem deutschen Projektleiter. Patrick führt das Beratungsgespräch, zeigt dir den Entwurf und bleibt bis zum Livegang und danach dein Kontakt. Du bekommst nie eine Mail, die du zweimal lesen musst.",
  },
  {
    q: "Was passiert in den ersten drei Tagen?",
    a: "Direkt nach dem 60-Minuten-Gespräch nimmt sich ein Entwickler fünf Stunden Zeit und baut einen echten Entwurf, keine Skizze. Drei Tage nach dem Gespräch siehst du ihn auf einer Vorschau-Adresse, zusammen mit einem konkreten Angebot für das fertige Projekt.",
  },
  {
    q: "Was ist, wenn mir der Entwurf nicht gefällt?",
    a: "Dann endet es hier, und du schuldest nichts. Keine Anzahlung, keine Aufwandspauschale. Die fünf Stunden sind unser Einsatz, nicht deiner. Wir behalten den Entwurf, du behältst deine Zeit.",
  },
  {
    q: "Was kostet eine Website?",
    a: "Ein Onepager kostet 1.499 €, eine Website mit mehreren Unterseiten 1.999 €, jeweils als Festpreis. Relaunches, mehrere Sprachen oder Anbindungen an andere Systeme rechnen wir nach Absprache. Auch dann bekommst du den Festpreis zusammen mit dem Entwurf, nicht erst nach einem Workshop.",
  },
  {
    q: "Wann muss ich bezahlen?",
    a: "Erst wenn deine Website ausgeliefert ist. Es gibt keine Anzahlung. Den Entwurf siehst du vorher kostenlos, das Angebot mit Festpreis bekommst du dazu. Die Rechnung kommt, wenn die fertige Seite bei dir ist.",
  },
  {
    q: "Wie lange dauert die Umsetzung?",
    a: "Das hängt vom Umfang ab und steht konkret im Angebot, das du mit dem Entwurf bekommst. Ein Onepager oder eine Website mit ein paar Unterseiten geht schnell, ein Relaunch mit vielen Seiten oder Schnittstellen dauert länger. Nach der Umsetzung hast du bis zu zwei Feedbackrunden.",
  },
  {
    q: "Wie viele Änderungen sind drin?",
    a: "Bis zu zwei Feedbackrunden nach der Umsetzung, im Festpreis enthalten. In jeder Runde sammelst du alles, was dir auffällt, wir setzen es um. Das reicht in der Praxis fast immer, weil der Entwurf vorher schon den Ton gesetzt hat.",
  },
  {
    q: "Wer ist mein Vertragspartner?",
    // PLATZHALTER: Firmierung und rechtliche Details prüfen
    a: "Vertragspartner ist die RepuFox LLC, die Betreiberin von Flottmacher. Vertrag und Kommunikation sind auf Deutsch, die Rechnung kommt in Euro. Als Unternehmen in Deutschland verbuchst du sie in der Regel im Reverse-Charge-Verfahren, dein Steuerberater kennt das.",
  },
  {
    q: "Werde ich bei Google gefunden?",
    a: "Die technische Grundlage ist in jedem Paket drin: schnelle Ladezeiten, Titel und Beschreibung für jede Seite, strukturierte Daten zu deinem Betrieb, Sitemap und Anmeldung in der Google Search Console. Einen bestimmten Platz kann dir niemand seriös versprechen. Willst du in deiner Region weiter nach oben, kümmern wir uns auf Wunsch um dein Google-Unternehmensprofil und deine Bewertungen und messen, wo du bei Google Maps stehst.",
  },
  {
    q: "Wo wird die Website gehostet?",
    a: "Auf Servern in Deutschland, bei einem Hoster deiner Wahl und auf deinen Namen: IONOS, Strato oder wo immer du willst. Wir registrieren Domain und Hosting gemeinsam mit dir und richten alles ein. Zugänge, Code und Rechte liegen bei dir, nicht bei uns.",
  },
  {
    q: "Liefert ihr Texte und Bilder?",
    a: "Texte ja, dein Projektleiter schreibt sie nach dem Beratungsgespräch. Bilder: eigene Fotos sind am besten, wir sagen dir genau, welche wir brauchen. Wo keine sind, arbeiten wir mit passenden Stock- oder KI-Bildern und sagen dir, wo ein Fotoshooting den Unterschied machen würde.",
  },
  {
    q: "Baut ihr auch Shops oder Schnittstellen?",
    a: "Anbindungen ja: Wenn deine Website mit CRM, Buchungstool oder Warenwirtschaft sprechen soll, bauen wir die Schnittstelle im Paket Individuell. Große Shops und eigenständige Software bauen wir nicht, dafür empfehlen wir dir gern Partner.",
  },
];
